module.exports = __webpack_public_path__ + "static/assets/6d19c16d3d9aa2e9e5d36f2a38f64890.png";